import styled from 'styled-components';
import { InputOption } from '../../../../../../new-lib/types/search-filters';
import { SelectedSort } from '../SortByContainer';

type sortyByFilter = {
  order_by?: string;
  order_direction?: string;
};

interface SortByPresentationpropsTypes {
  options: InputOption[];
  selectedValues: sortyByFilter;
  onChange: (selectedSort: SelectedSort) => void;
}

interface inputPropsType {
  option: InputOption;
}

const MobileSortByPresentation = ({
  options,
  selectedValues,
  onChange
}: SortByPresentationpropsTypes): JSX.Element => {
  const Input = ({ option }: inputPropsType) => {
    let isSelected = false;
    if (
      selectedValues.order_by &&
      selectedValues.order_direction &&
      selectedValues.order_by + selectedValues.order_direction ===
        option.value + option.options.direction
    ) {
      isSelected = true;
    }

    return (
      <div
        onClick={() => {
          onChange(
            isSelected
              ? { order: '', direction: '' }
              : {
                  order: option.value.toString(),
                  direction: option.options.direction
                }
          );
        }}
        className={isSelected ? 'sortselected' : ''}
        data-test="sort-option"
      >
        {option.options.displayedValue}
      </div>
    );
  };
  return (
    <Container>
      <div className="menu">
        {options.map((curr: InputOption, idx) => (
          <Input option={curr} key={idx} />
        ))}
      </div>
    </Container>
  );
};

const Container = styled.div`
  padding: 0px 25px;
  .sortselected {
    color: ${props => props.theme.light.colors.secondary};
    background-color: white;
    border: none;
    border-bottom: 1px solid
      ${props => props.theme.light.borderColors.secondary};
  }
  .menu {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: ${props => props.theme.light.colors.black};

    font-family: materialMedium;
    font-size: ${props => props.theme.font.sizes.l};
    cursor: pointer;
    div {
      display: flex;
      align-items: center;
      white-space: nowrap;
      height: 45px;
      border-bottom: 1px solid
        ${props => props.theme.light.borderColors.secondary};
      padding: 0 5px;
    }
    div:last-child {
      border-bottom: none;
    }
  }
`;

export default MobileSortByPresentation;
